export default __webpack_public_path__ + "static/media/sc1.07757c6d.png";